import styled from 'styled-components';
import { Card } from '@perch-labs/shrike';

export const CardImage = styled(Card.Image)`
  height: 300px;
  margin-top: 24px;
  object-fit: cover;
`;
